import { render, staticRenderFns } from "./NewsCoupon.html?vue&type=template&id=5a09c813&scoped=true&"
import script from "./NewsCoupon.vue?vue&type=script&lang=ts&"
export * from "./NewsCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./NewsCoupon.scss?vue&type=style&index=0&id=5a09c813&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a09c813",
  null
  
)

export default component.exports